"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributionStats = exports.retryFailedForVendor = exports.republishDistribution = exports.retryTransmission = exports.sendTestCopy = exports.getTransmissionAttempts = exports.getTestSends = exports.getDistribution = exports.listDistributions = exports.listDistributionsByReport = void 0;
const ApiClient_1 = require("../ApiClient");
const listDistributionsByReport = (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.rollupState)
        params.set('rollupState', filters.rollupState);
    if (filters.producer)
        params.set('producer', filters.producer);
    if (filters.page)
        params.set('page', String(filters.page));
    if (filters.perPage)
        params.set('perPage', String(filters.perPage));
    if (filters.ticker)
        params.set('ticker', filters.ticker);
    const query = params.toString();
    return ApiClient_1.apiClient.get(`/api/distributions/by-report${query ? `?${query}` : ''}`);
};
exports.listDistributionsByReport = listDistributionsByReport;
const listDistributions = (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.rollupState)
        params.set('rollupState', filters.rollupState);
    if (filters.producer)
        params.set('producer', filters.producer);
    if (filters.page)
        params.set('page', String(filters.page));
    if (filters.perPage)
        params.set('perPage', String(filters.perPage));
    const query = params.toString();
    return ApiClient_1.apiClient.get(`/api/distributions${query ? `?${query}` : ''}`);
};
exports.listDistributions = listDistributions;
const getDistribution = (id) => ApiClient_1.apiClient.get(`/api/distributions/${id}`);
exports.getDistribution = getDistribution;
const getTestSends = (distributionId) => ApiClient_1.apiClient.get(`/api/distributions/${distributionId}/test-sends`);
exports.getTestSends = getTestSends;
const getTransmissionAttempts = (distributionId) => ApiClient_1.apiClient.get(`/api/distributions/${distributionId}/attempts`);
exports.getTransmissionAttempts = getTransmissionAttempts;
const sendTestCopy = (distributionId, vendorId, verb) => ApiClient_1.apiClient.post(`/api/distributions/${distributionId}/vendors/${vendorId}/test-send`, { verb });
exports.sendTestCopy = sendTestCopy;
const retryTransmission = (distributionId, vendorId) => ApiClient_1.apiClient.post(`/api/distributions/${distributionId}/vendors/${vendorId}/retry`);
exports.retryTransmission = retryTransmission;
const republishDistribution = (distributionId) => ApiClient_1.apiClient.post(`/api/distributions/${distributionId}/republish`);
exports.republishDistribution = republishDistribution;
const retryFailedForVendor = (vendorId) => ApiClient_1.apiClient.post('/api/distributions/retry-failed', { vendorId });
exports.retryFailedForVendor = retryFailedForVendor;
const getDistributionStats = (from, to, kinds, producer = '') => ApiClient_1.apiClient.get(`/api/distributions/stats?${new URLSearchParams({ from, to, kinds: kinds.join(','), ...(producer ? { producer } : {}) }).toString()}`);
exports.getDistributionStats = getDistributionStats;
